module.exports = __webpack_public_path__ + "static/media/26UNRWA18.c6d54c8b.jpg";